module.exports = __webpack_public_path__ + "static/media/flip_icon.79facce0.svg";